export default __webpack_public_path__ + "static/media/List-documentation.96debd39.md";